import {
  WideCoinsEmptyState,
  ConnectEmptyState,
  DarkCoinsEmptyState,
  DarkConnectEmptyState,
  DarkDefaultEmptyState,
  DarkGraphDataEmptyState,
  DarkMarketplaceEmptyState,
  DarkPayoutMethodsEmptyState,
  DarkFileSearchEmptyState,
  DarkSignalsEmptyState,
  DarkTradesEmptyState,
  DefaultEmptyState,
  GraphDataEmptyState,
  MarketplaceEmptyState,
  PayoutMethodsEmptyState,
  SearchEmptyState,
  FileSearchEmptyState,
  SignalsEmptyState,
  TradesEmptyState,
  DarkSearchEmptyState,
  DarkReviewsEmptyState,
  ReviewsEmptyState,
  BotsEmptyState,
  DarkBotsEmptyState,
  DarkWideCoinsEmptyState,
  CoinsEmptyState,
  BacktestingHistoryEmptyState,
  DarkBacktestingHistoryEmptyState,
  DarkConfigurationEmptyState,
  ConfigurationEmptyState,
  DarkConfigurationSearchEmptyState,
  ConfigurationSearchEmptyState,
  UsersEmptyState,
  DarkUsersEmptyState,
  DarkFiltersEmptyState,
  FiltersEmptyState,
  GearsEmptyState,
  DarkGearsEmptyState,
} from "common/Icons/Icons.tsx";
import { useTheme } from "styled-components";
import { EmptyStatesIcons } from "common/Icons/types.ts";

export const useEmptyState = () => {
  const theme = useTheme();
  const lightModeEmptyStates: EmptyStatesIcons = {
    Empty: DefaultEmptyState,
    Trades: TradesEmptyState,
    Signals: SignalsEmptyState,
    Graph: GraphDataEmptyState,
    Marketplace: MarketplaceEmptyState,
    Coins: CoinsEmptyState,
    WideCoins: WideCoinsEmptyState,
    PayoutMethods: PayoutMethodsEmptyState,
    Connect: ConnectEmptyState,
    FileSearch: FileSearchEmptyState,
    Search: SearchEmptyState,
    Reviews: ReviewsEmptyState,
    Bots: BotsEmptyState,
    BacktestingHistory: BacktestingHistoryEmptyState,
    Configuration: ConfigurationEmptyState,
    ConfigurationSearch: ConfigurationSearchEmptyState,
    Users: UsersEmptyState,
    Filters: FiltersEmptyState,
    Gears: GearsEmptyState,
  };
  const darkModeEmptyStates: EmptyStatesIcons = {
    Empty: DarkDefaultEmptyState,
    Trades: DarkTradesEmptyState,
    Signals: DarkSignalsEmptyState,
    Graph: DarkGraphDataEmptyState,
    Marketplace: DarkMarketplaceEmptyState,
    Coins: DarkCoinsEmptyState,
    WideCoins: DarkWideCoinsEmptyState,
    PayoutMethods: DarkPayoutMethodsEmptyState,
    Connect: DarkConnectEmptyState,
    FileSearch: DarkFileSearchEmptyState,
    Search: DarkSearchEmptyState,
    Reviews: DarkReviewsEmptyState,
    Bots: DarkBotsEmptyState,
    BacktestingHistory: DarkBacktestingHistoryEmptyState,
    Configuration: DarkConfigurationEmptyState,
    ConfigurationSearch: DarkConfigurationSearchEmptyState,
    Users: DarkUsersEmptyState,
    Filters: DarkFiltersEmptyState,
    Gears: DarkGearsEmptyState,
  };

  return theme.isDarkMode ? darkModeEmptyStates : lightModeEmptyStates;
};
